//Checks if element is a child of the parentSelector
const checkIsParent = (element: Element, parentSelector: string): boolean => {
  const parent = document.querySelector(parentSelector);
  let node = element.parentNode;

  while (node != null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

//This checks if the parentSelector matches the parent of the element to determine when to scroll to the element
export const scrollToParent = (element: Element, parentSelector: string): void => {
  const parentNode = checkIsParent(element, parentSelector);
  if (parentNode) {
    element.parentElement.parentElement.scrollTo({
      behavior: 'auto',
      left: element.parentElement.offsetLeft - 8
    });
  }
};